import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

const TimecardHeaderButton = forwardRef(({
  onClick,
  onMouseDown,
  onMouseEnter,
  onMouseLeave,
  onFocus,
  onBlur,
  onTouchStart,
  onContextMenu,
  disabled = false,
  children,
  ariaLabel,
  className,
}, ref) => {
  const buttonClassName = className
    ? `timecards-header-button ${className}`
    : 'timecards-header-button';

  return (
    <button
      ref={ref}
      type="button"
      className={buttonClassName}
      onClick={onClick}
      onMouseDown={onMouseDown}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onFocus={onFocus}
      onBlur={onBlur}
      onTouchStart={onTouchStart}
      onContextMenu={onContextMenu}
      disabled={disabled}
      aria-label={ariaLabel}
    >
      {children}
    </button>
  );
});

TimecardHeaderButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  onMouseDown: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onTouchStart: PropTypes.func,
  onContextMenu: PropTypes.func,
  disabled: PropTypes.bool,
  children: PropTypes.node.isRequired,
  ariaLabel: PropTypes.string,
  className: PropTypes.string,
};

TimecardHeaderButton.defaultProps = {
  onMouseDown: undefined,
  onMouseEnter: undefined,
  onMouseLeave: undefined,
  onFocus: undefined,
  onBlur: undefined,
  onTouchStart: undefined,
  onContextMenu: undefined,
  disabled: false,
  ariaLabel: undefined,
  className: undefined,
};

export default TimecardHeaderButton;
